import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { StateUser } from '../../state_user';

export const remote_user_auth_provider_facebook_unlink = createAsyncThunkSafe<void, void>(
  ENUM__network_event_client_to_server.USER_AUTH_PROVIDER_FACEBOOK_UNLINK,
  async (): Promise<void> => {
    await send_to_server<void>(ENUM__network_event_client_to_server.USER_AUTH_PROVIDER_FACEBOOK_UNLINK);
  },
);

export function init_remote_user_auth_provider_facebook_unlink(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_auth_provider_facebook_unlink.pending, state => {})
    .addCase(remote_user_auth_provider_facebook_unlink.rejected, (state, action) => {})
    .addCase(remote_user_auth_provider_facebook_unlink.fulfilled, (state, action: PayloadAction) => {
      state.facebook_email = '';
    });
}
